<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/invoices">{{ $t('sale_invoice_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
            <b-btn v-if="step==2" variant="outline-primary no-bor" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('customer')}}</label>
                                <div>
                                    <CustomerDropdown @select="customerSelected" :value="header.CustomerName"></CustomerDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="form-group">
                                <label class="control-label blue">&nbsp;</label>
                                <div>
                                    <button v-if="step==1" type="button" class="btn btn-success btn-sm" @click="onGenerate"><i class="fa fa-plus-circle" aria-hidden="true"></i> {{$t('create_invoice')}}</button>
                                    <button v-if="step==2" type="button" class="btn btn-danger btn-sm" @click="onCancel"><i class="fa fa-times" aria-hidden="true"></i> {{$t('cancel')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('invoice_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('delivery_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.DueDate" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('sale_order')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.RefNum" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="step==1">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table table-bordered table-sm table-striped no-bor">
                                    <thead>
                                    <tr>
                                        <th class="text-center" style="width: 20px; line-height: 12px;"><input type="checkbox" @change="tickall"/></th>
                                        <th>{{ $t('stock_out_no') }}</th>
                                        <th>{{ $t('date') }}</th>
                                        <th>{{ $t('type') }}</th>
                                        <th>{{ $t('ref_num') }}</th>
                                        <th>{{ $t('branch')}}</th>
                                        <th>{{ $t('requestor') }}</th>
                                        <th>{{ $t('customer') }}</th>
                                        <th style="width: 80px;">{{$t('status')}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(ret, index) in stockouts" :key="index">
                                            <td class="text-center" style="line-height: 12px;">
                                                <input type="checkbox" v-model="ret.Checked"/>
                                            </td>
                                            <td>{{ret.Num}}</td>
                                            <td>{{$format(ret.OutDateAt, 'DD-MM-YYYY') }}</td>
                                            <td>{{ret.DocSource}}</td>
                                            <td>{{ret.DocSourceNo}}</td>
                                            <td>{{ret.BranchName}}</td>
                                            <td>{{ret.TakerOut}}</td>
                                            <td>{{ret.CustomerName}}</td>
                                            <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="step==2">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                    <th>{{$t('item_name')}}</th>
                                    <th>{{$t('item_code')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('unit_price')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td>{{ret.ItemCode}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td class="text-right">{{$dollar(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="6" class="text-right">សរុប / Total:</td>
                                    <td style="width: 120px;" class="text-right">{{$dollar(header.GrandTotal)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-right">អាករលើតម្លៃបន្ថែម VAT (10%):</td>
                                    <td style="width: 120px;" class="text-right">{{$dollar(header.TaxVat)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-right">សរុបរួម​/ Grand Total:</td>
                                    <td class="text-right">{{$dollar(header.TotalAmount)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-right">អត្រាប្តូរប្រាក់ប្រចាំថ្ងៃ:</td>
                                    <td class="text-right">R {{$money(header.ExchangeRate)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="6" class="text-right">ចំនួនទឹកប្រាក់ជាលុយរៀល:</td>
                                    <td class="text-right">R {{$money(header.TotalAmount*header.ExchangeRate)}}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CustomerDropdown } from '../Customer';
export default {
    components: { CustomerDropdown },
    data(){
        return {
            stockouts: [],
            header: {
                Date: this.$now().format('YYYY-MM-DD'),
                DueDate: this.$now().format('YYYY-MM-DD'),
                DeliveryDate: '',
                CustomerId: '',
                CustomerName: '',
                DocSource: 'Delivery',
                DocSourceNo: '',
                RefNum: '',
                ExchangeRate: 0,
                Status: 'Posted'
            },
            lines: [],
            links: [],
            step: 1
        }
    },
    mounted(){
        this.findExchangeRate();
    },
    methods: {
        stockOutList: function () {
            let loading = this.$loading.show();
            let req = {
                CustomerId: this.header.CustomerId,
                Limit: 0,
                Status: 'Posted'
            };
            this.$api().post('stockout', req).then(res => {
                if(this.$isValid(res)){
                    this.stockouts = res.data.Data;
                }
            }).finally(function(){ loading.hide(); });
        },
        customerSelected: function(e){
            this.header.CustomerId = e.Id;
            this.header.CustomerName = e.Name;
            this.stockOutList();
        },
        onSave: function() {
            if(this.step == 2){
                var req = {
                    Header: this.header,
                    Lines: this.lines,
                    Links: this.links
                };
                var loading = this.$loading.show();
                this.$api().post('sale/invoice/save', req).then(res => {
                    if(this.$isValid(res)){this.$router.push('/sale/invoices');}
                }).finally(function() { loading.hide(); });
            }
        },
        tickall: function (e) {
            this.stockouts.forEach(item => {
                item.Checked = e.target.checked;
            });
        },
        onGenerate: function(){
            let links = [];
            this.stockouts.forEach(element => {
                if(element.Checked) 
                {
                    links.push({
                        StockoutId: element.Id
                    });
                }
            });
            if(links.length > 0){
                this.links = links;
                this.$api().post('stockout/invoices', links).then(res => {
                    if(this.$isValid(res)){
                        this.lines = res.data.Json.Lines;
                        this.calculate();
                        this.step = 2;
                    }
                });
            }else{
                alert('Please try again');
            }
        },
        onCancel: function(){
            this.step = 1;
        },
        findExchangeRate: function(){
            this.$api().post('exchangerate/filter', { ExchangeDate: this.header.Date }).then(res => {
                if(this.$isValid(res)){
                    if(res.data.Json.ExchangeRate != null){
                        this.header.ExchangeRate = res.data.Json.ExchangeRate.Value;
                    }
                }
            });
        },
        calculate: function(){
            let gtotal = 0;
            this.lines.forEach(element => {
                gtotal += element.SubTotal;
            });
            this.header.GrandTotal = gtotal;
            this.header.UntaxAmount = gtotal;
            let vat = gtotal * 0.1;
            this.header.TaxVat = vat;
            this.header.TotalAmount = gtotal + vat;
        }
    }
}
</script>